import { render, staticRenderFns } from "./update-content.vue?vue&type=template&id=1557eca9&scoped=true"
import script from "./update-content.vue?vue&type=script&lang=ts"
export * from "./update-content.vue?vue&type=script&lang=ts"
import style0 from "./update-content.vue?vue&type=style&index=0&id=1557eca9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1557eca9",
  null
  
)

export default component.exports